import { useState } from "react";

export function useOrderSelection() {
  const [selectedOrderIds, setSelectedOrderIds] = useState<Set<string>>(
    new Set()
  );

  const toggleOrder = (id: string) =>
    setSelectedOrderIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  const toggleAll = (pageIds: string[]) =>
    setSelectedOrderIds((prev) => {
      const allSelected = pageIds.every((id) => prev.has(id));
      const next = new Set(prev);
      pageIds.forEach((id) => (allSelected ? next.delete(id) : next.add(id)));
      return next;
    });

  const clearSelection = () => setSelectedOrderIds(new Set());

  return { selectedOrderIds, toggleOrder, toggleAll, clearSelection };
}
